import { fareExpiredErrorCode } from '../../../constants/flights';

import { getErrorCodeFromEvent } from '../utils/getErrorCodeFromEvent';

export default (_context: any, event: any): boolean => {
  const errorCodeFromEvent = getErrorCodeFromEvent(event);

  return errorCodeFromEvent === fareExpiredErrorCode;
};
